import { Box, Skeleton } from '@mui/material';
import { DetailsModal } from './components/DetailsModal/DetailsModal.tsx';
import { ReportWrapper } from './components/Report';
import { useReportPage } from './hooks';

export const ReportPage = () => {
  const { isFormInitialized, hideSaveOptions } = useReportPage();

  return (
    <>
      <DetailsModal disabled={hideSaveOptions} />
      {isFormInitialized ? <ReportWrapper /> : <PageSkeleton />}
    </>
  );
};

const PageSkeleton = () => {
  return (
    <Box sx={{ p: 3 }}>
      <Skeleton variant='rectangular' height={40} sx={{ mb: 3 }} />

      <Box sx={{ display: 'flex', gap: 3 }}>
        <Box sx={{ flex: '0 0 30%' }}>
          <Skeleton variant='rectangular' height={200} sx={{ mb: 2 }} />
          <Skeleton variant='rectangular' height={'100%'} />
        </Box>

        <Box sx={{ flex: 1 }}>
          <Skeleton variant='rectangular' height={400} sx={{ mb: 2 }} />
          <Skeleton variant='rectangular' height={200} />
        </Box>
      </Box>
    </Box>
  );
};
